import React from "react";
import { Link } from "react-router-dom";

const PageTitle = ({ motherMenu, activeMenu, pageContent }) => {
  let path = window.location.pathname.split("/");

  return (
    <div className="row page-titles px-0 py-1 mx-0">
		<div className="mb-0 px-0">
			<h4 style={{ color: '#025d3a' }}>{pageContent}</h4>
		</div>
		<ol className="breadcrumb fs-7">
			<li className="breadcrumb-item"><Link to={`/${path[path.length - 1]}`}>{motherMenu}</Link></li>
			<li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
			<li className="breadcrumb-item active"><Link to={`/${path[path.length - 1]}`}>{activeMenu}</Link></li>
		</ol>
    </div>
  );
};

export default PageTitle;
